import { useTran } from 'src/i18n/useTran'
import { useTheme } from 'src/ui/style/useTheme'
import { FooterColumn } from 'src/layout/footer/FooterColumn'
import { View } from 'src/ui/basic/View'
import { verticalChildSpacing } from 'src/ui/style/mixins/layout'
import React from 'react'
import { msg } from 'src/i18n/texts/keys'
import { pages } from 'src/routing/pages'
import { UniversalLink } from 'src/routing/ui/UniversalLink'
import { useI18nDownloadTradingTermsLink } from 'src/business/static-pages/content/trading-terms/useI18nDownloadTradingTermsLink'
import { useChooseWarehouseLink } from 'src/business/landing-page/link/useChooseWarehouseLink'
import { openCookieBar } from 'src/ui/cookie-bar/cookieBarStore'
import { css } from 'src/ui/style/css'
import { getAppContext } from '../../context/AppContext'
import { CountryCode } from '../../api/defs/enums.type'

export const PagesColumn = () => {
    const t = useTran()
    const th = useTheme()
    const country = getAppContext().config.boxylandCountry as CountryCode

    // noinspection DuplicatedCode for now same as in MobileNavigation
    const pageNavItems: [string, string][] = [
        [msg.ui.nav.items.home, pages.Landing.to()],
        [msg.ui.nav.items.boxes, useChooseWarehouseLink()],
        [msg.ui.nav.items.shipments, pages.Shipments.to()],
        [msg.ui.nav.items.help, pages.Help.to()],
        [msg.ui.nav.items.tradingTerms, useI18nDownloadTradingTermsLink()],
        [msg.ui.nav.items.storePolicy, pages.StorePolicy.to()],
        [msg.ui.nav.items.gdpr, pages.Gdpr.to()]
    ]

    const showCompetitionLink = () => {
        if (country === CountryCode.SVK) {
            if (
                new Date().getMonth() === 11 &&
                new Date().getDate() <= 24 &&
                new Date().getFullYear() === 2025
            )
                return true
        }
        return false
    }

    return (
        <FooterColumn title={t(msg.ui.footer.pagesColumn.title)}>
            <View css={verticalChildSpacing(th.spacing.sm)}>
                {pageNavItems.map(([label, to]) => (
                    <UniversalLink key={label} to={to}>
                        {t(label)}
                    </UniversalLink>
                ))}
                <button
                    type="button"
                    onClick={openCookieBar}
                    css={css`
                        background: transparent;
                        border: none;
                        color: inherit;
                        padding: 0;
                        cursor: pointer;
                        text-align: left;
                        font: inherit;
                    `}
                >
                    {t(msg.ui.cookieBar.cookiesLink)}
                </button>
                {showCompetitionLink() && (
                    <UniversalLink
                        to={
                            'https://boxyland.s3.eu-west-3.amazonaws.com/public/docs/statutsutazesocial.pdf'
                        }
                    >
                        {t(msg.ui.nav.items.competition)}
                    </UniversalLink>
                )}
                {country === CountryCode.SVK && (
                    <UniversalLink to="https://forms.gle/x79VePwVim1LYsC26">
                        {t(msg.ui.nav.items.competition)}
                    </UniversalLink>
                )}
            </View>
        </FooterColumn>
    )
}
